<template>
  <div class="sepbody">
    <!--============    左侧大列表    ============================== -->
    <div class="sepbody_left">

      <!--      上传音频-->
      <div class="sep_first">
        <div class="sep_fir_lef">
            <div class="sep_fir_lef_up">
              <div class="sep_fir_lef_up_le">
                <div class="sep_fir_lef_up_le_da">Upload Audio</div>
                <div class="sep_fir_lef_up_le_xiao">Or Drag And Drop Mp3/Wav File Here</div>
              </div>
              <div class="sep_fir_lef_up_ri">
                <i class="el-icon-upload2" style="font-size: 50px"></i>
              </div>
            </div>
            <div class="sep_fir_lef_down">
              <el-upload class="" :file-list="fileList" :action="uploadUrl" name="file" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess"  :on-remove="handleRemove" :limit="1">
                <div v-if="root_path.length == 0" class="sep_fir_lef_down_box">
                  <i class="el-icon-plus" style="font-size: 30px"></i>
                </div>
              </el-upload>
            </div>
        </div>
        <!--<div class="sec_lef"></div>-->
      </div>

      <!--      各种参数-->
      <div class="sep_second">
        <!--      分离类型-->
        <div class="sep_type">
          <div class="sep_type_left">{{$t('mvsepFenLi')}}</div>
          <div class="sep_type_right">
            <el-select v-model="sep_type" placeholder="请选择" style="width: 300px" :popper-append-to-body="false">
              <el-option v-for="(item, index) in sep_type_options" :key="index" :label="item" :value="index">
              </el-option>
            </el-select>
          </div>
        </div>
        <!--      输出编码-->
        <div class="sep_type">
          <div class="sep_type_left">{{$t('mvsepShuChu')}}</div>
          <div class="sep_type_right">
            <el-select v-model="output_format" placeholder="请选择" style="width: 300px" :popper-append-to-body="false">
              <el-option v-for="(item, index) in output_format_options" :key="index" :label="item" :value="index">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <!--      我的积分详情-->
      <div class="wode">
        <span class="wodd bbttnn">{{$t('musicaiwodejifen')}}：{{myintegral}}</span>
        <el-divider class="wodd" direction="vertical"></el-divider>
        <span class="wodd bbttnn">{{$t('musicaixiaohaojifen')}}</span>
      </div>
      <!--    按钮-->
      <div class="fy_fiveth">
        <el-button v-if="button_unable" :loading="button_unable" class="gradient-btn">正在生成中</el-button>
        <el-button v-else   @click="createMvsep()" class="gradient-btn">立即生成</el-button>
      </div>
    </div>

    <!--============    右侧大列表    ==============================-->
    <div class="sepbody_right">
      <el-scrollbar class="mvsep_right_list"  wrap-style="overflow-x:hidden;">
        <div class="mvsep_right_list_m" v-for="(item,index) in tableData" :key="index">
          <div class="mvsep_m_title">{{item.file_name}}</div>
          <div class="mvsep_m_stpe">{{item.sep_type}}</div>

          <!-- 假状态 -->
          <div class="mvseplist_loding" v-if="item.loading == 'waiting'">
            <i  class="el-icon-loading" style="margin-right: 10px;font-size: 30px"></i>AI创作中，正在排队...
          </div>
          <div class="mvseplist_loding" v-else-if="item.loading == 'processing'">
            <el-progress style="width:80%;" :text-inside="true" :stroke-width="20" :percentage="item.percentage" status="success"></el-progress>
          </div>
          <div class="mvseplist_loding" v-else-if="item.loading == 'failed'">
            <i  class="el-icon-hot-water" style="margin-right: 10px;font-size: 30px"></i>分离失败...
          </div>

          <div class="mvsep_m_box" v-if="item.result">
            <mvsep-icon  :obj="item.result" :hash="item.hash"></mvsep-icon>
          </div>
        </div>

<!--        <el-empty v-show="tableData == 0" description="暂无音频"></el-empty>-->
      </el-scrollbar>
    </div>

  </div>

</template>

<script>
import MusicfyIcon from "@/components/content/MusicfyIcon";
import MvsepIcon from "@/components/content/MvsepIcon";
import {
  musicfyGetVoice, musicfyCreate, mvsepDataBase, mvsepCreate, mvsepGetList, integralDataBase,
} from "@/api/Mine";
import MusicAiIcon from "@/components/content/MusicAIIcon";
export default {
  name: "Mvsep",
  components: {
    MvsepIcon,
  },
  data() {
    return {
      sep_type_options:[],
      output_format_options:[],
      //sep_type_options:[{label:'Ensemble (vocals, instrum)',value:'26'},{label:'Ensemble (vocals, instrum, bass, drums, other)',value:'28'},{label:'Ensemble All-In (vocals, bass, drums, piano, guitar, lead/back vocals, other)',value:'30'},{label:'Demucs4 HT (vocals, drums, bass, other)',value:'20'},{label:'BS Roformer (vocals, instrumental)',value:'40'},{label:'MelBand Roformer (vocals, instrumental)',value:'48'},{label:'MDX23C (vocals, instrumental)',value:'25'},{label:'SCNet (vocals, instrumental)',value:'46'},{label:'MDX B (vocals, instrumental)',value:'23'},{label:'Ultimate Vocal Remover HQ (vocals, music)',value:'9'},{label:'Demucs4 Vocals 2023 (vocals, instrum)',value:'27'},{label:'MDX-B Karaoke (lead/back vocals)',value:'12'},{label:'MelBand Karaoke by viperx and aufr33 (lead/back vocals)',value:'49'},{label:'MVSep Piano (piano, other)',value:'29'},{label:'MVSep Guitar (guitar, other)',value:'31'},{label:'MVSep Bass (bass, other)',value:'41'},{label:'MVSep Drums (drums, other)',value:'44'},{label:'MVSep Strings (strings, other)',value:'52'},{label:'MVSep Wind (wind, other)',value:'54'},{label:'Vit Large 23 (vocals, instrum)',value:'33'},{label:'Reverb Removal (noreverb)',value:'22'},{label:'MVSep Crowd removal (crowd, other)',value:'34'},{label:'MVSep Demucs4HT DNR (dialog, sfx, music)',value:'24'},{label:'BandIt Plus (speech, music, effects)',value:'36'},{label:'BandIt v2 (speech, music, effects)',value:'45'},{label:'MVSep DnR v3 (speech, music, sfx)',value:'56'},{label:'DrumSep (kick, snare, cymbals, toms)',value:'37'},{label:'DeNoise by aufr33',value:'47'},{label:'Whisper (extract text from audio)',value:'39'},{label:'Medley Vox (Multi-singer separation)',value:'53'},{label:'MVSep Multichannel BS (vocals, instrumental)',value:'43'},{label:'Male/Female separation (by Sucial)',value:'57'},{label:'Demucs3 Model (vocals, drums, bass, other)',value:'10'},{label:'MDX A/B (vocals, drums, bass, other)',value:'7'},{label:'UVRv5 Demucs (vocals, music)',value:'17'},{label:'MVSep DNR (music, sfx, speech)',value:'18'},{label:'MVSep Vocal Model (vocals, music)',value:'19'},{label:'Demucs2 (vocals, drums, bass, other)',value:'13'},{label:'Danna Sep (vocals, drums, bass, other)',value:'15'},{label:'Byte Dance (vocals, drums, bass, other)',value:'16'},{label:'MVSep MelBand Roformer (vocals, instrum)',value:'35'},{label:'spleeter',value:'0'},{label:'UnMix',value:'3'},{label:'Zero Shot (Query Based) (Low quality)',value:'14'},{label:'LarsNet (kick, snare, cymbals, toms, hihat)',value:'38'},{label:'MVSep MultiSpeaker (MDX23C)',value:'42'},{label:'Apollo Enhancers (by JusperLee and Lew)',value:'51'},{label:'Aspiration (by Sucial)',value:'50'},{label:'Phantom Centre extraction (by wesleyr36)',value:'55'}],
      // output_format_options:[{label:'mp3 (320 kbps)',value:'0'},{label:'wav (uncompressed)',value:'1'},{label:'flac (lossless)',value:'2'},{label:'m4a (lossy)',value:'3'}],
      sep_type:'20',
      output_format:0,
      myintegral:0,
      root_path:'',
      fileList:[],
      // uploadUrl: "http://www.music.com/api/musicfyUpload",
      // uploadUrl: "https://ht.7keymusic.com/api/musicfyUpload",
      uploadUrl: process.env.VUE_APP_UPLOAD_MVSEP_URL,
      page:1,
      limit:20,
      voiceData:{},
      tableData:[],
      button_unable:false,
    }
  },
  computed: {

  },
  created() {
    this.mvsepDataBasefunc();//获取基础数据
    this.musicfyListfunc(); //获取右侧生成列表/
  },
  updated() {
    this.myintegral = JSON.parse(localStorage.getItem('myInfo')).integral
  },
  methods: {
    //++++++++++++++++    文件上传    +++++++++++++++ start
    beforeAvatarUpload(file){
      console.log(this.root_path)
      if(this.root_path.length > 1){
        this.$message.error('只能转换一个音频');
        this.fileList = []
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传音频大小不能超过 10MB!');
        this.fileList = []
        return
      }
      const isAudio = file.type === 'audio/mpeg';
      const isAudiowav = file.type === 'audio/wav';

      if (!isAudio && !isAudiowav) {
        this.$message.error('请上传指定格式音频');
        this.fileList = []
        return;
      }
    },
    handleAvatarSuccess(res, file) {
      console.log(res,file,'99999999999999')
      this.fileList =[{'name': file.name, 'url': res.data.path,'size':file.size}];
      this.root_path = res.data.path
    },
    handleRemove(file, fileList) {
      this.root_path = ''
    },
    //++++++++++++++++    文件上传    +++++++++++++++  end


    // ++++++++++++++++++++    立即生成按钮    +++++++++++++++++++++
    createMvsep(){
      if(this.fileList.length < 1) {
        this.$message.error('请上传音频');
        return
      }

      let params = {
        'file_info' : {'name':this.fileList[0].name,'size':this.fileList[0].size},
        'root_path' : this.root_path,
        'sep_type' : this.sep_type,
        'output_format' : this.output_format,
      }
      this.button_unable = true;
      mvsepCreate(params).then((res) => {
        if(res.status == 1){
          setTimeout(() => {
            this.button_unable = false;
            this.$router.go(0) && location.reload();
            // this.myintegral = this.myintegral - 10
            // console.log(this.myintegral)
            // this.musicfyListfunc(); //获取右侧生成列表/
          }, 1400)
        }else{
          this.button_unable = false;
        }
      }).catch((err) => {
        console.log(err, '生成失败');
        this.button_unable = false;
      });
    },

    //+++++++++++    获取右侧结果列表 +++++++++++++++++++++++++++++++=
    musicfyListfunc(){
      mvsepGetList().then((res) => {

        if (res.status == 1) {
          //当最新的作曲还在创作时候，轮询查询，直到接口返回repeat=0
          if(res.repeat == 1){
            res.data.forEach((item) => {
              if(item.loading == 'processing'){

                let jia_process = localStorage.getItem("process_" + item.hash);

                if(jia_process){
                  let new_jia_process = Number(jia_process) + Number(5)
                  if(new_jia_process >= 100){
                    localStorage.setItem("process_" + item.hash, 99);
                    item.percentage = 99
                  }else{

                    localStorage.setItem("process_" + item.hash, new_jia_process);
                    item.percentage = new_jia_process
                  }
                }else{
                  localStorage.setItem("process_" + item.hash, 1);
                  item.percentage = 1
                }
              }
            });
            setTimeout(this.musicfyListfunc, 5000);
          }
          this.tableData = res.data;
        } else {
          this.$message.error(res.msg)
        }


        this.tableData = res.data;
      }).catch((err) => {
        console.log(err, 'mvsep列表失败');
      });
    },

    // 积分基础套餐
    mvsepDataBasefunc() {
      mvsepDataBase().then((res) => {
        this.sep_type_options = res.data.sep_type
        this.output_format_options = res.data.output_format
        console.log(this.sep_type_options)
      }).catch((err) => {
            console.log(err, '积分基础套餐失败');
      });
    },


  },
}
</script>

<style scoped  lang='less'>
.sepbody {
  display: flex;
  flex-direction: row;
  width: 100%;
  .sepbody_left {
    display: flex;
    width: 40%;
    flex-direction: column;
    color: @headerSelectTextColor  !important;
  }
  .sepbody_right {
    margin-left: 15px;
    display: flex;
    width: 60%;
    flex-direction: column;
  }
}
::v-deep .el-input__inner{/*输入框*/
  border: 1px solid @popupLockTimeBorderColor;
  color: @headerSelectTextColor  !important;
  background-color: @recommendMusicianListBGColor;
  &:hover {
    border: 1px solid @popupCancelTextColor;
  }
}
::v-deep .el-select-dropdown{   /*select下拉框添加背景色*/
  border: 1px solid @popupLockTimeBorderColor;
  background-color: @personInfoFormColor !important;
}
::v-deep .el-select-dropdown__item { /*select下拉框字体颜色以及鼠标移入改变字体颜色*/
  background-color: @personInfoFormColor !important;
  color: @headerSelectTextColor !important; /* 设置文本颜色 */
  &:hover {
    color: @footerBackgroundColor !important; /* 设置文本颜色 */
    background-color: white !important;
  }
}
::v-deep .el-select-dropdown__item.selected {   /* 给下拉框中的选中项添加背景色 */
  background-color: #66b1ff !important;  /* 设置选中项的背景色 */
  color: beige !important;
}



//============ 右 侧 列 表 ==================
.mvsep_right_list {
  display: flex;
  flex-direction: column;
  width:100%;
  height: 550px;
  overflow-x: hidden;
  margin-top: 20px;
  border-radius: 10px;
  color: @headerSelectTextColor  !important;
  .mvsep_right_list_m {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    margin-right: 10px;
    background-color: @recommendMusicianListBGColor;
    border-radius: 10px;
    .mvsep_m_title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      width: 200px;
      padding: 10px 0 10px 10px;
    }
    .mvsep_m_stpe {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 13px;
      padding-bottom: 5px;
    }
    .mvseplist_loding {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      margin-bottom: 10px;
      margin-right: 10px;
      border-radius: 10px;
      width: 100%;
      height: 80px;

    }
    .mvsep_m_box {
      display: flex;
      flex:1;
      justify-content: center;
      align-items: center;
      padding-bottom: 10px;
    }

  }
}
//============ 左 侧 列 表 ==================

.sep_first {
  display: flex;
  margin:10px 0;
  border-radius: 15px;
  padding: 10px;
  background-color: @recommendMusicianListBGColor;
  .sep_fir_lef {
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    border-radius: 15px;
    border: 2px dashed @headerSelectTextColor  ;
    padding: 10px;
    .sep_fir_lef_up {
      display: flex;
      flex: 1;
      border-bottom: 2px solid @headerSelectTextColor;
      .sep_fir_lef_up_le {
        display: flex;
        flex-direction: column;
        flex: 3;
        padding: 10px;
        .sep_fir_lef_up_le_da {
          flex: 1;
          font-size: 26px;
          font-weight: 500;
          padding: 5px;

        }
        .sep_fir_lef_up_le_xiao {
          flex: 1;
          font-size: 17px;
          font-weight: 300;
          padding: 5px;

        }
      }
      .sep_fir_lef_up_ri {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
      }
    }
    .sep_fir_lef_down {
      cursor: pointer;
      display: flex;
      flex: 1;
      padding: 10px 10px 0 10px;
      .sep_fir_lef_down_box {
        display: flex;
        align-items: center;
        justify-content: center;
        border:2px solid @headerSelectTextColor;
        border-radius: 10px;
        width: 50px;
        height: 50px;
      }
    }
  }
}
.sep_second {
  display: flex;
  flex-direction: column;
  margin:10px 0;
  border-radius: 15px;
  padding: 10px;
  background-color: @recommendMusicianListBGColor;
  font-size: medium;
  .sep_type{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0px 10px 10px;
    .sep_type_left{
      //margin-left: 10px;
      flex: 1;
      padding: 10px;
    }
    .sep_type_right{
      flex: 3;
      padding: 10px;
    }
  }

}

.wode {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  .wodd {
    display: flex;
    font-size: 15px;
    margin: 10px;
  }
}
.fy_fiveth {
  display: flex;
  justify-content: center;
  align-items: center;
  margin:10px 0;
  border-radius: 15px;
  padding: 10px 0 10px 40px;
    .gradient-btn {
      background-image: linear-gradient(to right, #e6717d 0%, #b656f0 100%);
      border: none;
      color: white;
      padding: 10px 20px;
      text-align: center;
      text-decoration: none;
      display: inline-block;
      font-size: 20px;
      width: 300px;
      margin: 4px 2px;
      cursor: pointer;
      transition: background-image 0.5s ease;
    }
    .disabled_butt {
      background-color: #00BCA4;
    }
    .gradient-btn:hover {
      background-image: linear-gradient(to right, #b656f0 0%, #e6717d 100%);
    }

}



</style>